<template>
  <SummarySection :title="t('title')" @edit="$emit('edit')">
    <dl v-if="productRequired" class="mt-2 grid grid-cols-1 gap-x-3 gap-y-1.5 sm:grid-cols-2">
      <template v-if="isVirtual">
        <div class="sm:col-span-2">
          <dt class="text-xs font-medium text-gray-500">{{ t("type") }}</dt>
          <dd class="mt-0.5 text-sm text-gray-900">{{ t("internet_tv_offer") }}</dd>
        </div>
        <div v-if="product.lineHolderName">
          <dt class="text-xs font-medium text-gray-500">{{ t("line_holder") }}</dt>
          <dd class="mt-0.5 text-sm text-gray-900">{{ product.lineHolderName }}</dd>
        </div>
        <div v-if="product.referenceId">
          <dt class="text-xs font-medium text-gray-500">{{ t("contract_reference") }}</dt>
          <dd class="mt-0.5 text-sm text-gray-900">{{ product.referenceId }}</dd>
        </div>
        <div v-if="product.transactionDate">
          <dt class="text-xs font-medium text-gray-500">{{ t("subscription_date") }}</dt>
          <dd class="mt-0.5 text-sm text-gray-900">{{ product.transactionDate }}</dd>
        </div>
      </template>
      <template v-else>
        <div v-if="product.title" class="sm:col-span-2">
          <dt class="text-xs font-medium text-gray-500">{{ t("product_title") }}</dt>
          <dd class="mt-0.5 text-sm text-gray-900">{{ product.title }}</dd>
        </div>
        <div v-if="product.referenceId">
          <dt class="text-xs font-medium text-gray-500">{{ t("reference") }}</dt>
          <dd class="mt-0.5 text-sm text-gray-900">{{ product.referenceId }}</dd>
        </div>
        <div v-if="product.price">
          <dt class="text-xs font-medium text-gray-500">{{ t("price") }}</dt>
          <dd class="mt-0.5 text-sm text-gray-900 font-medium">{{ product.price }}€</dd>
        </div>
      </template>
    </dl>
  </SummarySection>
</template>

<script>
import { useI18n } from "vue-i18n";
import { isVirtualProduct } from "@estaly/ui";
import SummarySection from "./SummarySection.vue";

export default {
  components: { SummarySection },
  emits: ["edit"],
  props: {
    product: {
      type: Object,
      required: true,
    },
    productless: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
  computed: {
    productRequired() {
      return !this.productless;
    },
    isVirtual() {
      return isVirtualProduct(this.product);
    },
  },
};
</script>

<i18n src="./SummaryProductSection.i18n.json"></i18n>
